// Shared thread display-name logic - the ONLY copy (v50 landmine 87: three
// copy-pasted versions diverged silently; the Home tile got missed in a fix).
// client -> patient name + MRN - Care Team | dm -> other members | group -> title, else members.
export const threadLabel = (t) => {
  if (!t) return '';
  if (t.thread_type === 'client')
    return (t.patient_name || 'Client') + (t.patient_mrn ? ' \u00b7 ' + t.patient_mrn : '') + ' - Care Team';
  if (t.thread_type === 'dm') return t.other_names || 'Direct message';
  if (t.title) return t.title;
  return t.other_names || 'Group';
};
